import React, { useState } from 'react';

function App() {
    const [openSection, setOpenSection] = useState(null);

    const toggleSection = (section) => {
        setOpenSection(openSection === section ? null : section);
    };

    return (
        <div className="bg-white text-gray-900 min-h-screen flex items-center justify-center p-6">
            <div className="max-w-4xl w-full mx-auto py-16 px-6 sm:px-8 lg:px-10">
                <h1 className="text-center text-3xl sm:text-4xl font-bold mb-4">Take a Look at How We Work</h1>
                <p className="text-center text-lg text-gray-600 mb-10">
                    Automate your processes to increase productivity and regain control of your time.
                </p>

                {/** Sections */}
                {[
                    { id: 1, title: "Driven by Strategy", content: "We may work with robots all day, but we’re very human. We’ll tailor our strategy around your industry, needs, and goals. Copy-paste? No thanks." },
                    { id: 2, title: "Part of Your Team", content: "We’re all in. Add us to your slack channels, email us with concerns, and have your vendors reach out directly. We'll be your Chief Automation Officer." },
                    { id: 3, title: "Innovators to the Core", content: "We’ll solve your bottlenecks—whether we need to go over, under, or through. We combine expertise + creativity to work out your knots." }
                ].map((section) => (
                    <div key={section.id} className="border-t border-gray-300 py-5">
                        <div 
                            className="flex justify-between items-center cursor-pointer transition-all hover:bg-gray-100 p-3 rounded-lg"
                            onClick={() => toggleSection(section.id)}
                        >
                            <span className="text-lg sm:text-xl font-semibold text-gray-700">{section.id < 10 ? `0${section.id}` : section.id}</span>
                            <h2 className="text-xl sm:text-2xl font-semibold flex-1 text-left ml-4">{section.title}</h2>
                            <i className={`fas text-xl transition-transform duration-300 ${openSection === section.id ? 'fa-chevron-up' : 'fa-chevron-down'}`} />
                        </div>
                        {openSection === section.id && (
                            <div className="mt-3 p-3 text-lg text-gray-600 bg-gray-50 rounded-lg">
                                <p>{section.content}</p>
                            </div>
                        )}
                    </div>
                ))}
            </div>
        </div>
    );
}

export default App;
